<template>
  <div id="movement-filter">
    <dropdown-card
      class="dropdown-card"
      height="fit-content"
      :isOpen="cardIsOpen"
    >
      <template slot="header">
        <div class="header-part">
          <div class="header-icon">
            <img src="/static/icons/filter-icon.svg" />
          </div>
          <div class="header-title">
            {{ $t("movementsScreen.movementsFilter.header") }}
          </div>
        </div>
      </template>
      <template>
        <template v-if="isLoading"></template>
        <template v-if="!isLoading">
          <div class="filter-body">
            <div class="filter-wrapper">
              <div class="filter date">
                <date-picker
                  v-model="date"
                  :label="$t('movementsScreen.movementsFilter.body.date')"
                  :inputFormat="'YYYY. MMMM D'"
                  :titleFormat="'YYYY-MM-DD'"
                />
              </div>
              <div class="filter">
                <auto-complete
                  :keys="partners.map(x => x.id)"
                  :values="partners.map(item => item.name)"
                  v-model="partnerID"
                  :placeholderText="
                    $t('movementsScreen.movementsFilter.body.partner')
                  "
                  :label="$t('movementsScreen.movementsFilter.body.partner')"
                  :canAddNewOption="false"
                  :keepOpen="false"
                />
              </div>
            </div>
            <div class="button-wrapper">
              <rounded-button
                buttonType="danger"
                :isOutline="true"
                width="45%"
                class="button"
                position="left"
                @click="removeFilter"
              >
                {{ $t("movementsScreen.movementsFilter.body.removeFilter") }}
              </rounded-button>
              <rounded-button
                width="45%"
                @click="filterData"
                class="button"
                position="right"
              >
                {{ $t("movementsScreen.movementsFilter.body.filterButton") }}
              </rounded-button>
            </div>
          </div>
        </template>
      </template>
    </dropdown-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "../../shared/DatePicker.vue";
export default {
  name: "MovementFilter",
  props: {},
  components: { DatePicker },
  data: () => ({
    partnerID: undefined,
    partners: [],
    date: undefined,
    isLoading: false
  }),
  created() {
    this.isLoading = true;
    this.getPartners();
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    }),
    computedData() {
      let filter = undefined;
      if (this.date !== undefined) {
        if (filter === undefined) {
          filter = {};
        }
        filter["date"] = this.$moment(this.date).format("YYYY-MM-DD HH:mm");
      }
      if (this.partnerID !== undefined) {
        if (filter === undefined) {
          filter = {};
        }
        filter["partnerID"] = this.partnerID;
      }
      return filter;
    },
    cardIsOpen() {
      // return this.getWindowWidth > 760;
      return false;
    }
  },
  methods: {
    ...mapActions({
      readPartners: "partners/readPartners"
    }),
    getPartners() {
      this.readPartners()
        .then(res => {
          if (res.status === "OK") {
            this.partners = res.data;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => (this.isLoading = false));
    },
    removeFilter() {
      this.partnerID = undefined;
      this.date = undefined;
      this.$emit("clickedFilter", this.computedData);
    },
    filterData() {
      this.$emit("clickedFilter", this.computedData);
    }
  }
};
</script>

<style lang="scss" scoped>
#movement-filter {
  .dropdown-card {
    .header-part {
      display: flex;
      .header-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .header-title {
        font-weight: 550;
        color: #5a5a5a;
      }
    }
    .filter-body {
      padding-top: 10px !important;
      padding: 5px;
      .filter-wrapper {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px 15px;
        /deep/ #select-wrapper {
          .selectable-items {
            top: 0 !important;
          }
        }
        .date {
          display: flex;
          align-items: flex-end;
          /deep/ #date-picker {
            width: 100%;
            input {
              height: 40px;
            }
          }
        }
      }
      .button-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 25px;
        margin-bottom: 5px;
        .button {
          max-width: 200px;
        }
      }
    }
  }
}

@media (max-width: 760px) {
  .filter-wrapper {
    grid-template-columns: repeat(1, 1fr) !important;
    .double-filter {
      flex-direction: column !important;
      justify-content: unset !important;
      .position {
        width: 100% !important;
        margin-bottom: 10px !important;
      }
      .type {
        width: 100% !important;
      }
    }
  }
}
@media (max-width: 1600px) and (min-width: 761px) {
  .filter-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 1900px) and (min-width: 1601px) {
  .filter-wrapper {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
@media (min-width: 1901px) {
  .filter-wrapper {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}
</style>
